// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-btn-diciplina {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  padding: 10px 0 20px 0;
}

.discipline-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #c9d5ea;
  border-radius: 10px;
  background: #f7faff;
  color: #244a88;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 12px;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.discipline-action-btn:hover {
  background: #edf4ff;
  border-color: #9eb7e5;
}

.discipline-action-btn:active {
  transform: translateY(1px);
}

.discipline-action-btn-icon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
}

.discipline-action-btn--fault .discipline-action-btn-icon {
  background: #ffecee;
  color: #b33d4d;
}

.discipline-action-btn--note .discipline-action-btn-icon {
  background: #eaf2ff;
  color: #285bb4;
}

.discipline-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.discipline-search-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.discipline-search-container {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.discipline-search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.discipline-search-icon {
  position: absolute;
  right: 10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.discipline-search-results {
  position: absolute;
  top: 80px;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  padding: 5px;
  z-index: 123;
}

.discipline-search-result-item {
  padding: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.discipline-search-result-item:hover {
  background: #f0f0f0;
}

.discipline-selected {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.discipline-selected-item {
  font-size: 10px;
  background: var(--texto-destaque);
  color: white;
  padding: 2px 10px;
  border-radius: 5px;
  cursor: pointer;
}


/* container geral diciplina e faltas */
.container-dicipline-time-line {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
  padding: 12px 0 8px;
  align-items: start;
}

/* linha do tempo das faltas e notas */
.discipline-timeline {
  width: 100%;
  max-height: 700px;
  overflow-y: auto;
  padding: 14px;
  border: 1px solid #d7e1f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(20, 34, 66, 0.04);
}

.container-dicipline-time-line  .discipline-timeline h3 {
  margin-bottom: 12px;
  font-size: 15px;
  color: var(--texto-destaque);
  position: static;
}

/* Ajuste na linha do tempo */
.timeline-item-discipline,
.timeline-item-dicipline {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  margin-bottom: 0;
  position: relative;
}

.timeline-dot-span {
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0;
}

/* Ponto na linha do tempo */
.timeline-dot-discipline {
  width: 12px;
  height: 12px;
  background: var(--Vermelho);
  border-radius: 50%;
  flex-shrink: 0;
}

/* Data ao lado do dot */
.timeline-date-discipline {
  font-size: 12px;
  color: #607089;
  white-space: nowrap;
}

/* Ajuste do conteúdo da timeline */
.timeline-content-discipline {
  display: flex;
  flex-direction: column;
  background: #f8fbff;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #dfe8f5;
  border-left: 4px solid var(--texto-destaque);
  flex: 1 1;
  min-height: 60px;
  gap: 6px;
}

/* Título acima do texto da nota */
.timeline-content-discipline strong {
  font-size: 13px;
  color: #1f365c;
  line-height: 1.3;
}

.timeline-content-discipline > span {
  font-size: 13px;
  color: #2f3d54;
  line-height: 1.4;
}

/* Nota maior */
.timeline-content-discipline p {
  margin: 0;
  font-size: 13px;
  color: #333;
  line-height: 1.4;
  white-space: pre-wrap;
}

/* Ajustes para exibir as informações adicionais */
.timeline-extra-info {
  font-size: 13px;
  color: #23344f;
  margin-top: 2px;
  padding-top: 6px;
  border-top: 1px dashed #dbe4f2;
}

.timeline-extra-info strong {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #4b6286;
  margin-bottom: 2px;
}

.timeline-extra-info span {
  display: block;
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
}

.discipline-timeline ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

@media (max-width: 640px) {
  .container-btn-diciplina {
    justify-content: stretch;
  }

  .discipline-action-btn {
    width: 100%;
    justify-content: center;
  }
}

.file-link {
  display: inline-block;
  margin-bottom: 6px;
  color: #007bff;
  text-decoration: underline;
  font-size: 0.9rem;
}
.file-link:hover {
  color: var(--texto-destaque);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Disciplina/discipline.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mFAAmF;AACrF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA,uCAAuC;AACvC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,SAAO;EACP,gBAAgB;EAChB,QAAQ;AACV;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[".container-btn-diciplina {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  padding: 10px 0 20px 0;\n}\n\n.discipline-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #c9d5ea;\n  border-radius: 10px;\n  background: #f7faff;\n  color: #244a88;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 7px 12px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.discipline-action-btn:hover {\n  background: #edf4ff;\n  border-color: #9eb7e5;\n}\n\n.discipline-action-btn:active {\n  transform: translateY(1px);\n}\n\n.discipline-action-btn-icon {\n  width: 18px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.discipline-action-btn--fault .discipline-action-btn-icon {\n  background: #ffecee;\n  color: #b33d4d;\n}\n\n.discipline-action-btn--note .discipline-action-btn-icon {\n  background: #eaf2ff;\n  color: #285bb4;\n}\n\n.discipline-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.discipline-search-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.discipline-search-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.discipline-search-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.discipline-search-icon {\n  position: absolute;\n  right: 10px;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.discipline-search-results {\n  position: absolute;\n  top: 80px;\n  max-height: 200px;\n  overflow-y: auto;\n  background: #fff;\n  border: 1px solid #ddd;\n  padding: 5px;\n  z-index: 123;\n}\n\n.discipline-search-result-item {\n  padding: 4px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.discipline-search-result-item:hover {\n  background: #f0f0f0;\n}\n\n.discipline-selected {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.discipline-selected-item {\n  font-size: 10px;\n  background: var(--texto-destaque);\n  color: white;\n  padding: 2px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n\n/* container geral diciplina e faltas */\n.container-dicipline-time-line {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 16px;\n  padding: 12px 0 8px;\n  align-items: start;\n}\n\n/* linha do tempo das faltas e notas */\n.discipline-timeline {\n  width: 100%;\n  max-height: 700px;\n  overflow-y: auto;\n  padding: 14px;\n  border: 1px solid #d7e1f0;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(20, 34, 66, 0.04);\n}\n\n.container-dicipline-time-line  .discipline-timeline h3 {\n  margin-bottom: 12px;\n  font-size: 15px;\n  color: var(--texto-destaque);\n  position: static;\n}\n\n/* Ajuste na linha do tempo */\n.timeline-item-discipline,\n.timeline-item-dicipline {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  margin-bottom: 0;\n  position: relative;\n}\n\n.timeline-dot-span {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin: 0;\n}\n\n/* Ponto na linha do tempo */\n.timeline-dot-discipline {\n  width: 12px;\n  height: 12px;\n  background: var(--Vermelho);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n/* Data ao lado do dot */\n.timeline-date-discipline {\n  font-size: 12px;\n  color: #607089;\n  white-space: nowrap;\n}\n\n/* Ajuste do conteúdo da timeline */\n.timeline-content-discipline {\n  display: flex;\n  flex-direction: column;\n  background: #f8fbff;\n  padding: 12px 14px;\n  border-radius: 10px;\n  border: 1px solid #dfe8f5;\n  border-left: 4px solid var(--texto-destaque);\n  flex: 1;\n  min-height: 60px;\n  gap: 6px;\n}\n\n/* Título acima do texto da nota */\n.timeline-content-discipline strong {\n  font-size: 13px;\n  color: #1f365c;\n  line-height: 1.3;\n}\n\n.timeline-content-discipline > span {\n  font-size: 13px;\n  color: #2f3d54;\n  line-height: 1.4;\n}\n\n/* Nota maior */\n.timeline-content-discipline p {\n  margin: 0;\n  font-size: 13px;\n  color: #333;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n/* Ajustes para exibir as informações adicionais */\n.timeline-extra-info {\n  font-size: 13px;\n  color: #23344f;\n  margin-top: 2px;\n  padding-top: 6px;\n  border-top: 1px dashed #dbe4f2;\n}\n\n.timeline-extra-info strong {\n  display: block;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #4b6286;\n  margin-bottom: 2px;\n}\n\n.timeline-extra-info span {\n  display: block;\n  font-size: 13px;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.discipline-timeline ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n@media (max-width: 640px) {\n  .container-btn-diciplina {\n    justify-content: stretch;\n  }\n\n  .discipline-action-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.file-link {\n  display: inline-block;\n  margin-bottom: 6px;\n  color: #007bff;\n  text-decoration: underline;\n  font-size: 0.9rem;\n}\n.file-link:hover {\n  color: var(--texto-destaque);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
